export default __webpack_public_path__ + "static/media/photo03_pc@2x.d39b46ba.jpg";